import { render, staticRenderFns } from "./SpecPopupDsV2.vue?vue&type=template&id=1f0c4e40&scoped=true&"
import script from "./SpecPopupDsV2.vue?vue&type=script&lang=js&"
export * from "./SpecPopupDsV2.vue?vue&type=script&lang=js&"
import style0 from "./SpecPopupDsV2.vue?vue&type=style&index=0&id=1f0c4e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c4e40",
  null
  
)

export default component.exports